//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import triangleIcon from '@/assets/icons/triangle.png'
import refreshIcon from '@/assets/icons/refresh.png'
import oasis from '@/lib/api.oasis.js'
import native from '../../lib/native'
import mulClassSelect from '@/components/clinic/mulClassSelect.vue'
import { fail } from 'assert';
export default {
  // props: ['data'],
  data() {
    return {
      province: [],
      city: [],
      area: [],
      hodCity: [],
      triangle: triangleIcon,
      refresh: refreshIcon,
      activeTab: '', // address/subject
      // tabs 的文字
      isActive: '', // address, subject
      tabsText: ['北京', '科室'],
      currentCity: '城市',
      currentSubj: '科室',
      prevProvince: '', // 前一个被选中的省
      curProvince: '', // 当前被选中的省
      prevCity: '',
      curCity: '',
      prevArea: '',
      curArea: '',
      prevHodCity: '',
      curHodCity: '',
      showHodCity: false, // bool
      // addressResult: { province: '', city: '', area: '', hodCity: '' }, // 地址选择的结果 { province: '', city: '', area: '' }
      addressResult: { province: '', city: '', area: '', hodCity: '' }, // 地址选择的结果 { province: '', city: '', area: '' }
      subject: [], // [[], {}, {}, {}....]
      subjectSelected: [{ layer: 0, index: '', deptId: '' }], // index 当前层数， num 第几个数据
      foo: '',
      box: [],
      directeCity: { areacode: '', areaname: '' }, // 直辖市的数据
      newPositionCity: '',
      citys: '正在定位中...',
      currentPosition: {},
      rotateNum: 0 // icon 旋转的圈数
    }
  },
  props:{
    isSelctKeshi:{
      type:Boolean,
      default:true
    }
  },
  computed: {
    borderComp: function() {
      if (this.isActive !== '') {
        this.bodyOverflow(true)
        return {
          'border-bottom': '1px solid #f2f5f8'
        }
      } else {
        this.bodyOverflow(false)
        return {}
      }
    },
    // 选择地址的高度
    // selectPositionHeight: function () {
    //   return {
    //     // height: '100vh - 2rem'
    //   }
    // },
    // 根据可见区域的高度设置body的高度
    ch: function() {
      let h = document.documentElement.clientHeight
      if (this.isActive === '') {
        return {}
      }
      return {
        height: h + 'px'
      }
    },
    showCity: function() {
      if (this.curProvince === '') {
        return false
      }
      return !this.province[this.curProvince].isDirect
    },
    showArea: function() {
      if (this.curProvince === '') {
        return false
      } else {
        if (this.curCity !== '' || this.province[this.curProvince].isDirect) {
          return true
        } else {
          return false
        }
      }
    },
    cityData: function() {
      return this.city
    },
    areaData: function() {
      let province = this.data.address.province[this.curProvince]
      if (province.isDirect) {
        return province.area
      } else {
        if (this.curCity !== '') {
          return province.city[this.curCity].area
        }
      }
    },
    subjectComp: function() {
      let boxArr = []
      let last = this.subjectSelected[this.subjectSelected.length - 1]
      boxArr.push(this.subject[0])
      console.log(last);
      if (last.deptId !== '') {
        for (let i = 0; i < this.subjectSelected.length; i++) {
          boxArr.push(this.subject[i + 1][this.subjectSelected[i].deptId])
        }
      }
      console.log(boxArr)
      return boxArr
    }
  },
  components: {
    mulClassSelect
  },
  watch: {
    isActive: function (newValue, oldValue) {
      let hospitalList = document.getElementsByClassName('nearbyHospitalList')[0]
      let doctorBox = document.getElementsByClassName('doctorBox')[0]
      if (newValue === '') {
        if (hospitalList) {
          hospitalList.style.cssText = ''
        }
        if (doctorBox) {
          doctorBox.style.cssText = ''
        }
      } else {
        if (hospitalList) {
          hospitalList.style.height = '0'
          hospitalList.style.overflow = 'hidden'
        }
        if (doctorBox) {
          doctorBox.style.height = '0'
          doctorBox.style.overflow = 'hidden'
        }
      }
    }
  },
  methods: {
    color(){
      let className='myRed'
      if(this.currentCity!=='城市'){
        return className
      }
    },
    colors(){
      let className='myRed'
      if(this.currentSubj!=='科室'){
        return className
      }
    },
    dangLocation() { //  这个函数没有用到.
      native.getPosition().then(position => {
        this.citys = position.city;
      })
      if (this.newPositionCity == '') {
        return this.citys
      } else {
        return this.newPositionCity
      }
    },
    // 旋转icon
    rotateIcon () {
      this.rotateNum++
    },
    refreshs() {
      this.rotateIcon()
      console.log('refreshs')
      // console.log(this.newPositionCity,'before')
      // this.newPositionCity = '重新定位中'
      // console.log(this.newPositionCity,'after')
      native.getPosition().then(position => {
        // this.currentPosition = position
        console.log(position)
        // 整理数据 start
        let p = {
          areacode: "",
          text: position.province,
          isDirect: false,
          isActive: false
        },
          c = {
            text: position.city,
            areacode: position.cityCode,
            isActive: false
          },
          a = {
            text: position.area,
            areacode: "",
            isActive: false
          },
          h = {
            text: "",
            areacode: "",
            isActive: ""
          }
        this.currentPosition.province = p
        this.currentPosition.city = c
        this.currentPosition.area = a
        this.currentPosition.hodCity = h
        // 整理数据 end
        // 显示定位信息
        this.citys = position.city
        // 
        // setInterval(function(){
        //   this.newPositionCity = position.city;
        // },2000)
        // console.log(this.newPositionCity,'last')
        // if (position == '') {
        //   this.newPositionCity = '重新定位中'
        // } else {
        //   this.newPositionCity = position.city;
        // }
        // console.log('position',this.newPosition)
        // console.log('this.newPosition.city',this.newPosition.city)
      }).catch(error => {
        this.citys = '定位失败'
      })
    },
    // 切换选项卡
    switchTab: function(string) {
      // let hospitalList = document.getElementsByClassName('nearbyHospitalList')[0]
      // let doctorBox = document.getElementsByClassName('doctorBox')[0]
      if (this.isActive === string) {
        this.isActive = ''
        // if (hospitalList) {
        //   hospitalList.style.cssText = ''
        // }
        // if (doctorBox) {
        //   doctorBox.style.cssText = ''
        // }
      } else {
        this.isActive = string
        // if (hospitalList) {
        //   hospitalList.style.height = '0'
        //   hospitalList.style.overflow = 'hidden'
        // }
        // if (doctorBox) {
        //   doctorBox.style.height = '0'
        //   doctorBox.style.overflow = 'hidden'
        // }
      }
      // 打开地址栏时刷当前位置
      if (string === 'address') {
        this.refreshs()
      }
    },
    // body overflow
    bodyOverflow: function(bool) {
      let body = document.getElementsByTagName('body')[0]
      if (bool) {
        body.style.overflow = 'hidden'
      } else {
        body.style.overflow = ''
      }
    },
    showHodCityMethod: function() {
      // 清除选中的旧地址
      if (this.curArea !== '') {
        this.clearAreaSelect()
      }
      if (this.curCity !== '') {
        this.clearCitySelect()
      }
      if (this.curProvince !== '') {
        this.clearProvinceSelect()
      }
      // 选中新地址
      this.showHodCity = true
      // 请求热门城市数据
      this.getHodCity()
      // 整理地址结果
      this.addressResult.province = ''
      this.addressResult.city = ''
      this.addressResult.area = ''
      if (this.curHodCity !== '') {
        // this.addressResult.hodCity = this.hodCity[this.curHodCity].text
        this.addressResult.hodCity = this.hodCity[this.curHodCity]
      } else {
        this.addressResult.hodCity = ''
      }
      // this.addressResult.province = {}
    },
    switchProvince: function(index) {
      // 清除选中的旧地址
      if (this.curArea !== '') {
        this.clearAreaSelect()
      }
      if (this.curCity !== '') {
        this.clearCitySelect()
      }
      this.showHodCity = false
      // 选中新地址
      this.prevProvince = this.curProvince
      this.curProvince = index
      if (this.prevProvince !== '') {
        this.province[this.prevProvince].isActive = false
      }
      this.province[this.curProvince].isActive = true
      // 请求城市数据
      this.getCity(this.curProvince)
      // 整理地址结果
      // this.addressResult.province = this.province[this.curProvince].text
      this.addressResult.province = this.province[this.curProvince]
      this.addressResult.city = ''
      this.addressResult.area = ''
      this.addressResult.hodCity = ''
      // console.log(this.addressResult);
    },
    switchCity: function(index) {
      // 清除区
      if (this.curArea !== '') {
        this.clearAreaSelect()
      }
      // 选择city
      this.prevCity = this.curCity
      this.curCity = index
      if (this.prevCity !== '') {
        this.city[this.prevCity].isActive = false
      }
      this.city[this.curCity].isActive = true
      // 请求县区数据
      this.getArea(this.curCity)
      // 整理地址结果
      // this.addressResult.city = this.city[this.curCity].text
      this.addressResult.city = this.city[this.curCity]
      this.addressResult.area = ''
      // console.log(this.data.address.province[this.curProvince].city[this.curCity]);
      console.log(this.addressResult, 'city');
    },
    switchArea: function(index) {
      this.prevArea = this.curArea
      this.curArea = index
      if (this.prevArea !== '') {
        this.area[this.prevArea].isActive = false
      }
      this.area[this.curArea].isActive = true
      // this.addressResult.area = this.area[this.curArea].text
      this.addressResult.area = this.area[this.curArea]
      console.log(this.addressResult, 'addressResult');
      this.closeTabSelect()
    },
    switchHodCity: function(index) {
      this.prevHodCity = this.curHodCity
      this.curHodCity = index
      if (this.prevHodCity) {
        this.hodCity[this.prevHodCity].isActive = false
      }
      this.hodCity[this.curHodCity].isActive = true
      // this.addressResult.hodCity = this.hodCity[this.curHodCity].text
      this.addressResult.hodCity = this.hodCity[this.curHodCity]
      this.closeTabSelect()
    },
    // 清除选择
    clearProvinceSelect: function() {
      if (this.curProvince !== '') {
        this.province[this.curProvince].isActive = false
      }
      this.prevProvince = ''
      this.curProvince = ''
    },
    clearCitySelect: function() {
      if (this.curCity !== '') {
        this.city[this.curCity].isActive = false
      }
      this.prevCity = ''
      this.curCity = ''
    },
    clearAreaSelect: function() {
      if (this.curArea !== '') {
        this.area[this.curArea].isActive = false
      }
      this.prevArea = ''
      this.curArea = ''
    },
    closeTabSelect: function(bool) {
      // console.log(this.isActive)
      if (this.isActive === 'subject') {
        this.calcResultSubject() // 展示选择结果
      }
      if (this.isActive === 'address') {
        // this.calcResultAddress() // 展示选择结果
        if (!bool) {
          this.calcResultAddress() // 展示选择结果
        } else {
          this.calcCurAddress()
        }
      }
      this.isActive = ''
      this.showHodCity = false
      if (!bool) {
        // 触发请求事件
        this.getSelectedData()
      } else {
        this.getCurPData()
      }
      // console.log('close');
    },
    getProvince: function() {
      let info = {}
      oasis.postProvinceData(info).then(response => {
        // console.log(response,'省----------------------')
        let tempArr = []
        // let directArr = []
        response.data.forEach(function(item, index, arr) {
          let obj = {}
          // obj.areacode
          // obj.text
          // obj.isDirect
          // obj.isActive
          obj.areacode = item.areacode
          obj.text = item.areaname
          // obj.isDirect = false
          if (item.areaname.indexOf('省') > -1 || item.areaname.indexOf('区') > -1) {
            obj.isDirect = false
          } else {
            obj.isDirect = true
          }
          obj.isActive = false
          tempArr.push(obj)
        })
        this.province = tempArr
      }).catch(error => {
        console.log(error)
      })
    },
    getCity: function(num) {
      // console.log(num);
      let provinces = this.province,
        info = {
          areacode: provinces[num].areacode
        },
        that = this
      // console.log(this.province)
      if (!this.province[num].isDirect) { // 选择非直辖市，省
        oasis.postCityData(info).then(response => {
          // console.log(response,'市----------------------')
          let tempArr = []
          response.data.forEach(function(item, index, arr) {
            let obj = {}
            // obj.text
            // obj.areacode
            // obj.isActive
            obj.text = item.areaname
            obj.areacode = item.areacode
            // obj.isDirect = false
            obj.isActive = false
            tempArr.push(obj)
          })
          this.city = tempArr
          // console.log(this.city)
        }).catch(error => {
          console.log(error)
        })
      } else { // 选择直辖市
        oasis.postCityData(info).then(response => {
          // console.log(response,'市----------------------')
          info = {
            parentid: response.data[0].areacode
          }
          // 把数据添加到市级
          that.directeCity = {
            areacode: response.data[0].areacode,
            areaname: response.data[0].areaname
          }
          console.log(this.directeCity, 'that.directeCity')
          console.log(this.addressResult, 'that.addressResult')
          // this.city.text = this.directeCity.areaname
          // this.city.areacode = this.directeCity.areacode
          that.addressResult.city = {}
          that.addressResult.city.areacode = that.directeCity.areacode
          that.addressResult.city.text = that.directeCity.areaname
          that.addressResult.city.isActive = true
          console.log(this.addressResult, 'that.addressResult')
          oasis.postAreaData(info).then(response => {
            let tempArr = []
            tempArr.push({
              text: '全部',
              areacode: '',
              // areacode: info.parentid,
              isActive: false
            })
            response.data.forEach(function(item, index, arr) {
              let obj = {}
              // obj.text
              // obj.areacode
              // obj.isActive
              obj.text = item.areaname
              obj.areacode = item.areacode
              tempArr.push(obj)
            })
            this.area = tempArr
          })
        }).catch(error => {
          console.log(error)
        })
      }
    },
    getArea: function(num) {
      let info = { parentid: this.city[num].areacode }
      oasis.postAreaData(info).then(response => {
        // console.log(response,'区----------------------')
        let tempArr = []
        tempArr.push({
          text: '全部',
          areacode: '',
          isActive: false
        })
        response.data.forEach(function(item, index, arr) {
          let obj = {}
          // obj.text
          // obj.areacode
          // obj.isActive
          obj.text = item.areaname
          obj.areacode = item.areacode
          obj.isActive = false
          tempArr.push(obj)
        })
        this.area = tempArr
      }).catch(error => {
        console.log(error)
      })
    },
    getHodCity: function() {
      // let info =
      oasis.postHodCityData().then((response) => {
        // console.log(response)
        let tempArr = []
        response.datalist.forEach(function(item, index, arr) {
          let obj = {}
          obj.text = item.areaname
          obj.areacode = item.areacode
          obj.isActive = false
          tempArr.push(obj)
        })
        this.hodCity = tempArr
        // console.log(this.hodCity)
      }).catch(error => {
        console.log(error)
      })
    },
    // 得到主科室数据
    getSubject: function() {
      oasis.postDept().then((response) => {
        let tempArr = []
        // tempArr.push({
        //   text: '全部',
        //   deptId: '',
        //   isActive: false,
        //   trail: false
        // })
        // 只取前500个科室
        let part = response.datalist.splice(0, 500)
        console.log(part, 'part')
        part.forEach(function(item, index, arr) {
          let obj = {}
          obj.text = item.name
          obj.deptId = item.deptid
          obj.isActive = false
          obj.trail = false
          tempArr.push(obj)
        })
        this.subject = [tempArr]
        this.box.push(tempArr)
        // console.log(this.box);
      }).catch(error => {
        console.log(error)
      })
    },
    // 得到子级科室数据
    getSubSubject: function(selected) {
      // layer 第几层
      //  index 第几个数据
      // 保存数据
      this.subjectSelected = selected
      // [
      //   layer: number,
      //   index: number,
      //   deptId: number/string
      // ]
      //
      let curLayerAfter = null
      let last = this.subjectSelected[this.subjectSelected.length - 1]
      if (this.subject[last.layer + 1] === undefined) {
        this.subject[last.layer + 1] = {}
      }
      curLayerAfter = this.subject[last.layer + 1]
      if (curLayerAfter[last.index] === undefined) {
        let tempArr = []
        let info = { parentid: last.deptId }
        let that = this
        tempArr.push({
          text: '全部',
          deptId: '',
          isActive: false,
          trail: true
        })
        oasis.postDeptSub(info).then((response) => {
          response.datalist.forEach(function(item, index, arr) {
            let obj = Object.create(null)
            obj.text = item.name
            obj.deptId = item.deptid
            obj.isActive = false
            obj.trail = true
            tempArr.push(obj)
          })
          curLayerAfter[last.deptId] = tempArr
          that.subject[last.layer + 1] = curLayerAfter
          that.box = []
          that.box.push(that.subject[0])
          for (let i = 0, iLen = that.subjectSelected.length; i < iLen; i++) {
            that.box.push(that.subject[i + 1][that.subjectSelected[i].deptId])
          }
          console.log(that.box)
        }).catch(error => {
          console.log(error)
        })
      }
    },
    calcResultAddress: function() {
      let ar = this.addressResult
      // console.log(ar, 'arararar')
      if (ar.area.text === '全部') { // 选择全部
        if (ar.city !== '') { // 省
          this.currentCity = ar.city.text
        } else { // 直辖市
          // this.currentCity = ar.province.text
          this.currentCity = ar.province.text.indexOf('市') < 0 ? ar.province.text + '市' : ar.province.text
          // 选择直辖市的全部区时返回市级数据
          let obj = {
            areacode: this.directeCity.areacode,
            text: this.directeCity.areaname,
            isAcitve: true
          }
          if (obj.text.indexOf('市') < 0) {
            obj.text += '市'
          }
          this.addressResult.city = obj
        }
      } else {
        if (ar.area === '') {
          this.currentCity = ar.hodCity.text
        } else {
          this.currentCity = ar.area.text
        }
      }
    },
    calcCurAddress: function () {
      let curp = this.currentPosition
      this.currentCity = curp.city.text ? curp.city.text : curp.province.text
    },
    calcResultSubject: function() {
      let ss = this.subjectSelected,
        subject = this.subject,
        box = this.box,
        result = {}
      // {
      //   subject: [
      //     {
      //       deptId:
      //       isActive:
      //       text:
      //       trail:
      //     },...
      //   ]
      //   address: []
      // }
      let tempArr = []
      // ss.forEach(function (item, index, arr) {
      //   let tempObj = subject[item.layer][item.deptId]
      //   let obj = Object.create(null)
      //   obj.text = tempObj.text
      //   obj.deptId = tempObj.deptId
      //   obj.isActive = tempObj.isActive
      //   obj.trail = tempObj.trail
      //   tempArr.push(obj)
      // })
      // result.subject = tempArr
      let obj = Object.create(null)
      let tempObj = box[0][ss[0].index]
      obj.text = tempObj.text
      obj.deptId = tempObj.deptId
      obj.isActive = tempObj.isActive
      obj.trail = tempObj.trail
      tempArr.push(obj)
      obj = Object.create(null)
      tempObj = box[1][ss[1].index]
      obj.text = tempObj.text
      obj.deptId = tempObj.deptId
      obj.isActive = tempObj.isActive
      obj.trail = tempObj.trail
      tempArr.push(obj)
      result.subject = tempArr
      // console.log(result)
      // 修改tab
      if (result.subject !== undefined) {
        for (let iLen = result.subject.length, i = iLen - 1; i > -1; i--) {
          if (result.subject[i].deptId !== '') {
            this.currentSubj = result.subject[i].text
            break
          }
        }
      }
      // if (result.address !== undefined ) {
      //   for (iLen = result.address.length, i = iLen - 1; i > -1; i--) {
      //     if (result.address[i].deptId !== '') {
      //       this.currentCity = result.address[i].text
      //       break
      //     }
      //   }
      // }
      // this.currentSubj =
      return result
    },
    // 向后台请求符合筛选条件的数据
    // 使用方法：
    // <parnet @getDataList="fn"></parent>
    getSelectedData: function() {
      let params = Object.create(null),
        subject = Object.create(null)
      params.address = this.addressResult
      console.log(this.addressResult, 'addressResult')
      if (this.box.length > 1) {
        let obj = Object.create(null)
        obj.text = this.box[1][this.subjectSelected[1].index].text
        obj.deptId = this.box[1][this.subjectSelected[1].index].deptId
        params.subject = {
          text: this.box[0][this.subjectSelected[0].index].text,
          deptId: this.box[0][this.subjectSelected[0].index].deptId,
          child: obj
        }
      } else {
        params.subject = {
          text: '',
          deptId: ''
        }
      }
      // console.log(params, 'params')
      this.$emit('getDataList', params)
    },
    // 点击当前位置时发送请求数据的事件
    getCurPData: function () {
      console.log('switchCurP')
      let params = Object.create(null)
      params.address = this.currentPosition
      if (this.box.length > 1) {
        let obj = Object.create(null)
        obj.text = this.box[1][this.subjectSelected[1].index].text
        obj.deptId = this.box[1][this.subjectSelected[1].index].deptId
        params.subject = {
          text: this.box[0][this.subjectSelected[0].index].text,
          deptId: this.box[0][this.subjectSelected[0].index].deptId,
          child: obj
        }
      } else {
        params.subject = {
          text: '',
          deptId: ''
        }
      }
      console.log(params, 'params')
      this.$emit('getDataList', params)
    },
    //
    switchCurP: function () {
      this.closeTabSelect(true)
    }
  },
  mounted() {
    this.getProvince()
    this.getHodCity()
    this.getSubject()
  }
}




// WEBPACK FOOTER //
// ./src/components/clinic/oldTabSelect.vue